import React from 'react';
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useParams,
  useHistory
} from 'react-router-dom';

import { useAuth } from './auth';

import Notfound from '../public/notfound/notfound';
import Home from '../private/home/home';
import Login from '../public/login/login';

const Auth = () => {
  const { session } = useAuth();
  return session?.goHome ? <Home /> : <Login />;
};

export default () => (
  <HashRouter>
    <Switch>
      <Route path="/:token/:condominio">
        <Auth />
      </Route>
      <Route path="/notfound">
        <Notfound />
      </Route>
      <Route path="*">
        <Redirect to="/notfound" />
      </Route>
    </Switch>
  </HashRouter>
);

interface Params {
  token: string;
  condominio: string;
}

interface Query {
  redirect?: string;
}

function factoryRouteQuery(query: string) {
  return String(query)
    .replace('?', '')
    .split('&')
    .reduce((acc, x) => {
      if (!x) return acc;
      const [key, value] = x.split('=');
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {} as Query);
}

export function useRoute() {
  const history = useHistory();
  return {
    params: useParams<Params>(),
    route: useRouteMatch(),
    history,
    query: factoryRouteQuery(history.location.search)
  };
}
